import React from "react";

function HowtoBuy() {
  return (
    <>
      <section className="  pb-4 pb-md-5    how">
        <div className="container">
          <div className="row ">
            <div className="col-md-10 m-auto">
              <div className="text-center mb-2">
                <h2 className="hadding hadding_bg d-inline-block mb-0 fw300 pt-4 pb-4" data-aos="fade-up">
                  How To Buy?
                </h2>
              </div>
              <div className="row">
                <div className="col-md-6 mt-4" data-aos="fade-right">
                  <div className="how_box">
                    <h5 className="color1 tx-upercase">
                      Step 1 : Connect Your Wallet
                    </h5>
                    <p>
                      Use Phantom, Solflare, or any Solana-compatible wallet to
                      connect to the site.
                    </p>
                  </div>
                </div>
                <div className="col-md-6 mt-4" data-aos="fade-left">
                  <div className="how_box">
                    <h5 className="color1 tx-upercase">
                      Step 2 : Fund Your wallet
                    </h5>
                    <p>
                      Ensure you have SOL for gas fees and USDC/USDT on the
                      solana network to swap for $SCOTTY.
                    </p>
                  </div>
                </div>
                <div className="col-md-6 mt-4" data-aos="fade-right">
                  <div className="how_box">
                    <h5 className="color1 tx-upercase">
                      Step 3 : Swap Tokens For $SCOTTY
                    </h5>
                    <p>
                      Use our built-in swap widget, confirm the transaction, and
                      join the Scotty revolution.
                    </p>
                  </div>
                </div>
                <div className="col-md-6 mt-4" data-aos="fade-left">
                  <div className="how_box">
                    <h5 className="color1 tx-upercase">
                      Step 4 : APE & SHOOT FOR THE MOON
                    </h5>
                    <p>
                      Scotty V1 was a 100x gem. Scotty V2 is ready to
                      outperform. Same community, same team, improved project
                      and now on Solana.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default HowtoBuy;
